import CtaIntroduce from '../CtaIntroduce'
import styles from './FollowBannerCta.module.css'
import React from 'react'
import { useCta } from '../../../../hooks/useCta'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

interface FollowBannerCtaProps {
    isVisible: boolean
    onCtaClick?: (_linkParams?: Record<string, string | number>) => void
}

export const FollowBannerCta: React.FC<FollowBannerCtaProps> = ({ isVisible, onCtaClick }) => {
    const { handleCtaClick } = useCta()
    const { dataClickLabel } = useAbTestGtm()
    
    const handleClick = onCtaClick || handleCtaClick
    
    return(
        <div className={`${styles.followBannerWrap} ${isVisible ? styles.show : ''}`}>
            <CtaIntroduce
                ctaId="Fixed_Google"
                onCtaClick={handleClick}
                dataClickLabel={dataClickLabel('FD_Fixed_CVボタン')}
            />
        </div>
    )
}
